var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tabData),function(item,index){return _c('span',{key:index,class:_vm.currentClick == item.value ? 'defult-color active' : 'defult-color',style:({
      'cursor': 'pointer',
      'margin-right': '12px',
    }),on:{"click":function($event){return _vm.tabClick(item.value)}}},[_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":item.value}}),_vm._v(_vm._s(item.label))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }